/**
 * @fileoverview QouteView
 * @version 1.1
 * @author Jennifer Mancilla
 * @date 14/02/2023
 * @copyright 2023 Industrias RESSER S.A de C.V
 */
import React, { useState, useEffect, useRef } from 'react';
import {
    Button,
    Col,
    Row,
    Space,
    Steps,
    message,
} from 'antd';
import { ToggleButtonGroup } from '@mui/material';
import { ToggleButton } from '@mui/material';
import { Fonts, showEkatenaView } from '../utils/constants';
import { useAppSelector, useAppDispatch } from '../hooks/storeHooks';
import { CurrentsSteps, StepController } from '../interfaces/enums';
import {
    activeImage,
    backBttn,
    nexBttn,
    stepperContainer,
    stepsContainer,
    TitleFormularioContainer,
} from '../styles/StepsStyles';
import styles from '../styles/Step.style';
import { fullHeight } from '../styles/CommonStyles';
import { getCurrentStep, } from '../functions/getCurrentStep';
import {
    setValidateFirstStep,
    setValidateThirdStep,
    setValidateFifthStep,
    setValidateFourStep,
} from '../reducer/slices/Validates';
import { getSuccessEkatena, getActualStep, getIsDisableQuoteForm, getIsLoadingData, getQuoteType, getFolio } from '../reducer/slices/DataCotizador';
import Logo from '../assets/logos/blueLogoSvg.svg';
import CreditForm from '../components/CreditForm/CreditForm';
import ComponentPrice from '../components/Price/ComponentPrice';
import {
    ValidateCreditFirstStep,
    ValidateLeasingFirstStep,
    ValidateThirdStep,
    ValidateFifthStep,
    ValidateCotizacion,
    ValidateCotizacionPyme
} from '../functions/ValidateSteps';
import { setCreditObjPlazo, 
         setCreditResultadoCotizacion, 
         setObjActividad, 
         setObjActivo, 
         setFilteredObjActivo,
         setObjCanalArrendamiento,
         setLeasingResultCotizacion,
         setLeasingRentMargin, 
         setLeasingObjPlazo, 
         setUserID 
} from '../reducer/slices/DataResponse';
import { GetCotizacion as apiCotizacion } from '../apis/ApiCreditQuotation';
import { GetLeasingCotizacion as apiLeasingQuotation } from '../apis/ApiLeasingQuotation';
import { CreditResultCotizacion, CreditObjPlazo, LeasingResultCotizacion} from '../reducer/slices/DataResponse';
import GetActividadesEconomicas from '../apis/ApiActividadEconomica';
import FinalStepView from './FinalStep';
import { postCanal } from '../apis/ApiPOST';
import { createObjArrendamiento } from '../functions/createObjArrendamiento';
import { txtdefault } from '../styles/StepsStyles';
import AcceptView from './AcceptView';
import creditquotationbg from '../assets/creditquotationbg.png'
import GetPlazos from '../apis/ApiPlazos';
import { GetCanalDigital, GetCanalDigitalID } from '../apis/ApiCanalDigital';
import {
    getUserActivo,
} from '../reducer/slices/DataCotizador';
import { blockedPostalCodes } from '../constants/blockedPostalCodes';
const useStyle = styles;
/**
 * @title QouteView
 * @description Vista principal paa el cotizador Ekatena
 * @returns Fragment
 */
export const QouteView = (props: any) => {
    const classes = styles();
    const { width } = useAppSelector(state => state.dimensions);
    const dataCotizador = useAppSelector(state => state.DataCotizador);
    const dataResponse = useAppSelector(state => state.DataResponse);
    const rent = dataResponse?.LeasingResultCotizacion?.rent ?? 0;
    const dispatch = useAppDispatch();

    const [ViewAcceptBuro, setViewAcceptBuro] = useState<boolean>(false);
    // Referencia para el timer del debounce: evita llamadas al API mientras el
    // usuario sigue modificando el precio o los controles del paso 1.
    const leasingDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    // Contador de peticiones en vuelo: el spinner se apaga solo cuando este
    // contador llega a 0, evitando el parpadeo cuando hay dos llamadas seguidas.
    const pendingLeasingRequestsRef = useRef(0);
    const setActualStep = (value:number) => dispatch(getActualStep(value))
    const [currentStep, setCurrentStep] = useState<CurrentsSteps>(CurrentsSteps.FirstStep);
    const [loading, setLoading] = useState(false);
    const onChangeQuoteType = (event: any, value: number) => {
        dispatch(getQuoteType(value));
    };
    const isPostalCodeValid =
    dataCotizador.userCP?.length === 5 &&
    !blockedPostalCodes.has(dataCotizador.userCP);
    const quoteTypeList = [
        { id: 0, name: "Arrendamiento" },
        { id: 1, name: "Crédito" },
    ];
    
    useEffect(() => {
        dispatch(setValidateThirdStep(true));
        setCurrentStep(CurrentsSteps.FirstStep);
        dispatch(getIsLoadingData(false));
    }, []);


    useEffect(() => {
            GetActividadesEconomicas().then(async (res: any) => {
                let objActividades: { id: number, name: string }[] = [];
                res.items.sectoresEconomicos.map((element: any) => objActividades.push({ id: element.Id, name: element.Descripcion }));
                dispatch(setObjActividad(objActividades));
            });
    }
    , []);

    useEffect(() => {
        GetCanalDigital().then(async (res: any) => {
            let objActivo: { id: number, name: string, IsForPyme: boolean }[] = [];
            const activosLabels:any = {
                17: "Vehículos, SUV y Camiones",
                18: "Vehículos, SUV y Camiones con equipamiento adicional (caja seca,refrigerado, plataforma, etc)"
            };
            res.items.forEach((element: any) => objActivo.push({
                id: element.ActivoId, 
                name: activosLabels[element.ActivoId] || element.Descripcion,
                IsForPyme: element.IsForPyme })
            );
            dispatch(setObjActivo(objActivo));
            let filteredObjActivo = [];
            if (dataCotizador.leasingType === 0) {
                filteredObjActivo = objActivo.filter((item) => !item.IsForPyme && item.id !== 19 && item.id !== 26);
            } else {
                filteredObjActivo = objActivo.filter((item) => item.IsForPyme); 
            }
            dispatch(getUserActivo(filteredObjActivo[0].id));
            GetCanalDigitalID(filteredObjActivo[0].id).then(async (res: any) => {
                let objLeasingPlazo: { id: number, name: string }[] = [];
                res.items.map((res: any, index: number) => objLeasingPlazo.push({ id: index, name: res.PlazoMeses }));
                dispatch(setLeasingObjPlazo(objLeasingPlazo));
                dispatch(setObjCanalArrendamiento(res.items));
            });
            dispatch(setFilteredObjActivo(filteredObjActivo));
        });
    }, [dataCotizador.leasingType]);
    
    useEffect(() => {
        GetPlazos(dataCotizador).then((response: any) => {
            let result: CreditObjPlazo = [];
            if (dataCotizador.productTypeOption !== undefined) {
                const productInfo: CreditObjPlazo[0] = {
                    Fib_ConfiguradorCotizadorId: response.data.Fib_ConfiguradorCotizadorId,
                    Fib_Name: response.data.Fib_Name,
                    Fib_TipoPersona: response.data.Fib_TipoPersona,
                    Fib_EsArrendamiento: response.data.Fib_EsArrendamiento,
                    Fib_Segmento: response.data.Fib_Segmento,
                    Fib_IVA: response.data.Fib_IVA,
                    Fib_ComisionApertura: response.data.Fib_ComisionApertura,
                    Fib_VAU_Arrenda: response.data.Fib_VAU_Arrenda,
                    Fib_ISR_Arrenda: response.data.Fib_ISR_Arrenda,
                    Fib_PTU_Arrenda: response.data.Fib_PTU_Arrenda,
                    details: {
                        Fib_PlanContizadorDetalleId: response.data.details.Fib_PlanContizadorDetalleId,
                        Fib_ConfiguradorCotizadorId: response.data.details.Fib_ConfiguradorCotizadorId,
                        Fib_Antiguedad: response.data.details.Fib_Antiguedad,
                        Fib_Enganche: response.data.details.Fib_Enganche,
                        Fib_Tasa: response.data.details.Fib_Tasa,
                        Fib_Plazo: response.data.details.Fib_Plazo,
                        Fib_VAU_Arrenda: response.data.details.Fib_VAU_Arrenda,
                        terms:response.data.details.terms,
                        rates: response.data.details.rates,
                        vauRates: response.data.details.vauRates,
                        openingComission:response.data.details.openingComission,
                    }
                };
                result.push(productInfo); // Agregamos el objeto a la matriz result
            }
            dispatch(setCreditObjPlazo(result));
        });

    }, [dataCotizador.productTypeOption]);
      
    // Debounce de 700ms: el spinner se activa de inmediato al detectar cambios,
    // pero la llamada al API se retrasa para no disparar una petición por cada
    // tecla presionada. El contador pendingLeasingRequestsRef garantiza que el
    // spinner no se apague mientras haya otra petición todavía en curso.
    useEffect(() => {
        if (!(ValidateCotizacion(dataCotizador) || ValidateCotizacionPyme(dataCotizador))) return;
        if (leasingDebounceRef.current) clearTimeout(leasingDebounceRef.current);
        dispatch(getIsLoadingData(true));
        leasingDebounceRef.current = setTimeout(() => {
            pendingLeasingRequestsRef.current++;
            GetLeasingCotizacion().finally(() => {
                pendingLeasingRequestsRef.current--;
                if (pendingLeasingRequestsRef.current === 0) {
                    dispatch(getIsLoadingData(false));
                }
            });
        }, 700);
        return () => {
            if (leasingDebounceRef.current) clearTimeout(leasingDebounceRef.current);
            dispatch(getIsLoadingData(false));
        };
    }, [
        dataCotizador.userActivo,
        dataCotizador.assetDownPayment,
        dataCotizador.assetPrice,
        dataCotizador.userPlazo,
        dataCotizador.purchaseOption
    ]);  
      

    useEffect(() => {
        if(dataCotizador.credit !== 0 && dataCotizador.plazo !== 0 && dataCotizador.quoteType === 1){
            dispatch(getIsLoadingData(true))
            GetCreditCotizacion().then(() => {
                dispatch(getIsLoadingData(false));
            });
        }
    }, [dataCotizador.productTypeOption, 
        dataCotizador.credit, 
        dataCotizador.plazo,
        dataCotizador.quoteType
    ]);

    useEffect(() => {
        if (dataCotizador.SuccessEkatena) {
            setCurrentStep(CurrentsSteps.ThirdStep);
            setActualStep(dataCotizador.actualStep + 1);
        }
    }, [dataCotizador.SuccessEkatena]);

    useEffect(() => {
        if (dataCotizador.quoteType === 0) {

            if (rent < 0 ) {
                message.destroy();
                message.error(
                    "El monto de las rentas no puede ser negativo. Por favor seleccione un monto del anticipo menor para continuar."
                );
            }
        }
    }, [rent, dataCotizador.quoteType]);

    /**
     * @title ViewAcceptBuroCredito
     * @description Funcion para desplegar vista de aceptacion para consulta buro de credito
     */

    function ViewBuroCredito() {
        setViewAcceptBuro(!ViewAcceptBuro);
    }


    /**
     * @title GetBuroCredito
     * @description Funcion para la obtencion del buro de credito
    */

    function GetBuroCredito() {
        if (dataCotizador.quoteType === 0) {
            setLoading(true);
            const valor = dataCotizador.assetPrice === undefined ? 0 : dataCotizador.assetPrice * 0.75;
            postCanal(JSON.stringify(createObjArrendamiento(dataCotizador, dataResponse, valor)), dataCotizador)
            .then(async (response: any) => {
                dispatch(setUserID(response.preauthId));
                dispatch(getFolio(response.folio));
                const isMoral = (dataCotizador.userType === 0);
                setViewAcceptBuro(false);
                isMoral ? setCurrentStep(CurrentsSteps.SixStep) : setCurrentStep(CurrentsSteps.SixStep);
                setActualStep(dataCotizador.actualStep + 1)
            }).catch((error: any) => {
                message.destroy();
                message.error("Error en la preautorización de la consulta a Buro de Crédito");
            }).finally(() => {
                setLoading(false);
            });
        }else if (dataCotizador.quoteType === 1) {
            setLoading(true);
            postCanal(JSON.stringify(createObjArrendamiento(dataCotizador, dataResponse)), dataCotizador)
            .then(async (response: any) => {
                dispatch(setUserID(response.preauthId));
                dispatch(getFolio(response.folio));
                setCurrentStep(CurrentsSteps.SixStep);
                setActualStep(dataCotizador.actualStep + 1);
            })
            .catch((error: any) => {
                message.destroy();
                message.error("Error en la preautorización de la consulta a Buro de Crédito");
            })
            .finally(() => {
                setLoading(false);
            });
        }
    }


    /**
     * @title GetCotizacion
     * @description Funcion para calcular la cotizacion despues de ingresar todos los campos seleccionados
     */
    async function GetCreditCotizacion() {
        const response = await apiCotizacion(dataCotizador);
        let result: CreditResultCotizacion = [];
        if (dataCotizador.credit !== undefined) {
            const cotizacion: CreditResultCotizacion[0] = {
                calculus_name: response.data.calculus_name,
                calculus_code: response.data.calculus_code,
                credit_total: response.data.credit_total,
                downpayment_deposit: response.data.downpayment_deposit,
                amount_to_finance: response.data.amount_to_finance,
                total_payment: response.data.total_payment,
                credit_start_date: response.data.credit_start_date,
                grace_period_start_date: response.data.grace_period_start_date,
                credit_length_in_months: response.data.credit_length_in_months,
                rate: response.data.rate,
                grace_periods: response.data.grace_periods,
                administration_cost: response.data.administration_cost,
                terms: response.data.terms,            
            };
            result.push(cotizacion);
        }
        dispatch(setCreditResultadoCotizacion(result));
    }


    /**
     * @title GetLeasingCotizacion
     * @description Funcion para calcular la cotizacion despues de ingresar todos los campos seleccionados
     */
        function GetLeasingCotizacion(): Promise<void> {
            const data: "ResidualEstandar" | "ResidualMaximo" | "ResidualMinimo" | "_" = dataCotizador.purchaseOption;
            const residual = dataCotizador.purchaseOption === "_" ? "No element" : dataResponse.ObjCanalArrendamiento?.[dataCotizador.userPlazo]?.[data];

            return apiLeasingQuotation(dataCotizador, residual, dataResponse).then((response: any) => {
                let plazo: string;
                switch (dataCotizador.userPlazo) {
                    case 0:
                        plazo = "P12";
                        break;
                    case 1:
                        plazo = "P24";
                        break;
                    case 2:
                        plazo = "P36";
                        break;
                    case 3:
                        plazo = "P48";
                        break;
                    case 4:
                        plazo = "P60";
                        break;
                    default:
                        plazo = "P12";
                        break;
                }
                let result: LeasingResultCotizacion;
                if (dataCotizador.assetDownPayment !== undefined && dataCotizador.assetPrice !== undefined) {
                    const valorEquipo = dataCotizador.assetPrice;
                    const seguroPrimerAnio = 0;
                    const anticipo = dataCotizador.assetDownPayment;
                    const montoFinanciado = valorEquipo - (anticipo * 1.16);
                    result = {
                        rent: response.items[plazo].Rent,
                        pagoInicial: (dataCotizador.assetDownPayment + seguroPrimerAnio + response.items[plazo].Commission) * 1.16,
                        montoFinanciado: montoFinanciado,
                        valorEquipo: valorEquipo,
                        seguroPrimerAno: seguroPrimerAnio,
                        comisionApertura: response.items[plazo].Commission,
                        Anticipo: anticipo,
                        AdvanceRent:response.items[plazo].AdvanceRent,
                        AdvanceCommision:response.items[plazo].AdvanceCommision
                    }
                    
                }
                else {
                    result = {
                        rent: 0,
                        pagoInicial: 0,
                        montoFinanciado: 0,
                        valorEquipo: 0,
                        seguroPrimerAno: 0,
                        comisionApertura: 0,
                        Anticipo: 0,
                        AdvanceRent:0,
                        AdvanceCommision:0
                    }
                }
                dispatch(setLeasingRentMargin(response.items[plazo].RentMargin));
                dispatch(setLeasingResultCotizacion(result));
            })
        }   

    /**
     * @title NextView 
     * @description Refactorizar la función para controlar el flujo de la aplicación (paso actual)
    */
    function NextView() {
        if (currentStep === CurrentsSteps.FirstStep && dataCotizador.quoteType === 1) {
            if (dataCotizador.isLoadingData) {
                message.destroy();
                message.error({ content: 'Por favor espere, la cotización se está calculando', style: { fontFamily: Fonts.sspRegular } });
                return;
            }
            if (dataResponse.CreditResultCotizacion.length === 0) {
                message.destroy();
                message.error({ content: 'Por favor espere los resultados de la cotización', style: { fontFamily: Fonts.sspRegular } });
                return;
            }
            if (ValidateCreditFirstStep(dataCotizador)) {
                if (showEkatenaView) {
                    setCurrentStep(CurrentsSteps.Ekatena);
                    setActualStep(dataCotizador.actualStep + 1);
                    dispatch(getIsDisableQuoteForm(true));
                } else {
                    setCurrentStep(CurrentsSteps.ThirdStep);
                    setActualStep(dataCotizador.actualStep + 1);
                }
            } else {
                dispatch(setValidateFirstStep(false));
                return;
            }
        }

        if (currentStep === CurrentsSteps.FirstStep && dataCotizador.quoteType === 0) {
            if (dataCotizador.isLoadingData) {
                message.destroy();
                message.error({ content: 'Por favor espere, la cotización se está calculando', style: { fontFamily: Fonts.sspRegular } });
                return;
            }
            if (!dataResponse.LeasingResultCotizacion?.rent || dataResponse.LeasingResultCotizacion.rent <= 0) {
                message.destroy();
                message.error({ content: 'Por favor espere los resultados de la cotización', style: { fontFamily: Fonts.sspRegular } });
                return;
            }
            if (rent < 0) {
                message.destroy();
                message.error("El monto de las rentas no puede ser negativo. Por favor seleccione un monto del anticipo menor para continuar.");
                return;
            }
            if (ValidateLeasingFirstStep(dataCotizador)) {
                if (showEkatenaView) {
                    setCurrentStep(CurrentsSteps.Ekatena);
                    setActualStep(dataCotizador.actualStep + 1);
                } else {
                    setCurrentStep(CurrentsSteps.ThirdStep);
                    setActualStep(dataCotizador.actualStep + 1);
                }
            } else {
                dispatch(setValidateFirstStep(false));
                return;
            }
        }

        if (currentStep === CurrentsSteps.ThirdStep) {
            if (blockedPostalCodes.has(dataCotizador.userCP)) {
                message.destroy();
                message.error("Actualmente no tenemos cobertura en este código postal");
                return;
            }
            const isMoral = (dataCotizador.userType === 0);
            const formIsValid = ValidateThirdStep(dataCotizador);
            if (isMoral) {
              if (formIsValid) {
                setCurrentStep(CurrentsSteps.FifthStep);
                setActualStep(dataCotizador.actualStep + 1);
              } else {
                    dispatch(setValidateFourStep(false));
              }
            } else {
              if (formIsValid) {
                GetBuroCredito();
                ViewBuroCredito(); 
                setActualStep(dataCotizador.actualStep + 1);
              } else {
                dispatch(setValidateFourStep(false));
              }
            }
        }
        
        if (currentStep === CurrentsSteps.FifthStep) {
            if (ValidateFifthStep(dataCotizador)) {
                GetBuroCredito();
                ViewBuroCredito();                    
                setActualStep(dataCotizador.actualStep + 1);
            }
            else {
                dispatch(setValidateFifthStep(false));
            }
            }
    }

    /**
     * @title previewView 
     * @description Función para controlar el cambio a la vista previa al utilizar el botón "Regresar"
    */
    function previewView(){
        if (currentStep === CurrentsSteps.Ekatena){
            setCurrentStep(CurrentsSteps.FirstStep)
            setActualStep(dataCotizador.actualStep - 1);
            dispatch(getSuccessEkatena(false));
            if (dataCotizador.quoteType === 1){
                dispatch(getIsDisableQuoteForm(false));
            }
        }
    
        if (currentStep === CurrentsSteps.ThirdStep) {
            if (showEkatenaView) {
                setCurrentStep(CurrentsSteps.Ekatena);
                setActualStep(dataCotizador.actualStep - 1);
                dispatch(getSuccessEkatena(false));
            } else {
                setCurrentStep(CurrentsSteps.FirstStep);
                setActualStep(dataCotizador.actualStep - 1);
                // Ensure form is re-enabled if needed when going back to first step without Ekatena
                if (dataCotizador.quoteType === 1) {
                    dispatch(getIsDisableQuoteForm(false));
                }
            }
        }

        if (currentStep === CurrentsSteps.FifthStep){
            setCurrentStep(CurrentsSteps.ThirdStep);
            setActualStep(dataCotizador.actualStep - 1);
        }
    }
    /**
     * @title totalSteps 
     * @description Evalúa los diferentes caminos que puede tomar una cotización y en base a ello designa la cantidad de steps que contendrá el stepper
    */

    // Fragment

    return (
        <Row style={fullHeight}>
            {
                width > 700 &&
                <Col span={10}
                    style={{ backgroundImage: `url(${(creditquotationbg)})`, ...activeImage }}
                >
                    <div style={{ height: '90%', width: '80%' }}>
                        <img src={Logo} alt='Logo' style={{ width: '25%' }} />
                        <div style={{ width: "100%", height: '85%', margin: 'auto', marginTop: 60, justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            {dataCotizador.quoteType === 0 ? (
                                <ComponentPrice/>
                            ):(
                                <CreditForm/>
                            )}
                            
                        </div>
                        <p onClick={() => window.open("https://www.finbeabc.com.mx")} style={{ position: 'relative', top: '6%', fontSize: 18, color: "white", cursor: "pointer" }}>finbeabc.com.mx</p>
                    </div>
                </Col>
            }


            <Col md={14} xs={24} style={stepsContainer}>
                <Steps current={dataCotizador.actualStep} className={classes.stepperContainer} responsive={false}>
                    <Steps.Step style={{paddingRight:5}} />
                    <Steps.Step style={{paddingRight:5}} />
                    <Steps.Step style={{paddingRight:5}} />
                    <Steps.Step style={{paddingRight:5}} />
                    {dataCotizador.userType === 0 && <Steps.Step style={{paddingRight:5}} />}
                </Steps>
                {currentStep === CurrentsSteps.FirstStep &&(  
                    <>
                        {/* <h2 className={classes.quoteTypeTitle}>Arrendamiento</h2> */}
          
                        {/* <h2 className={classes.quoteTypeTitle}>Elija un tipo de Financiamiento</h2> */}
                        {/* <ToggleButtonGroup
                            color="primary"
                            exclusive 
                            value={dataCotizador.quoteType}
                            onChange={onChangeQuoteType}
                            aria-label="Platform"
                            >
                            {quoteTypeList.map((quoteType) => (
                                <ToggleButton className={classes.toggleButton} key={quoteType.id} value={quoteType.id}>
                                    {quoteType.name}
                                </ToggleButton>
                            ))}
                        </ToggleButtonGroup> */}
                    </>
                )}
                {
                    dataCotizador.autorizeNIP?
                            (<FinalStepView />) :
                            getCurrentStep(currentStep)
                }

                {
                    dataCotizador.autorizeNIP
                        ? (<></>)
                        : (
                            <Space style={{
                                width: '85%',
                                marginBottom: 30,
                                display: 'flex',
                                flexDirection: width <= 1024 ? 'column' : 'row',
                            }}>

                                {
                                    currentStep != CurrentsSteps.SixStep && (
                                        <>
                                            <div style={{ display: "flex", flexDirection: width <= 800 ? "column" : "row" }}>

                                                {

                                                (currentStep !== CurrentsSteps.FirstStep) &&    
                                                    <Button
                                                        shape='round'
                                                        style={{ ...backBttn, marginBottom: width < 800 ? 10 : 0 }}
                                                        onClick={() => previewView()}
                                                    >
                                                        Regresar
                                                    </Button>

                                                }
                                                {
                                                    (currentStep === CurrentsSteps.Ekatena )? (
                                                        <></>
                                                    ) : currentStep !== CurrentsSteps.FinalStep ?(
                                                        <>
                                                            <Button
                                                                className='nxtBttn'
                                                                shape='round'
                                                                style={{
                                                                    ...nexBttn,
                                                                    marginLeft: width <= 800 ? 0 : 10,
                                                                    opacity: (isPostalCodeValid && !(currentStep === CurrentsSteps.FirstStep && dataCotizador.isLoadingData)) ? 1 : 0.5,
                                                                    cursor: (isPostalCodeValid && !(currentStep === CurrentsSteps.FirstStep && dataCotizador.isLoadingData)) ? "pointer" : "not-allowed"
                                                                }}
                                                                onClick={NextView}
                                                                loading={loading}
                                                                disabled={loading || (currentStep === CurrentsSteps.FirstStep && dataCotizador.isLoadingData) || !isPostalCodeValid}
                                                            >
                                                                Siguiente
                                                            </Button>
                                                        </>
                                                    ): null
                                                }
                                            </div>
                                            {[CurrentsSteps.ThirdStep, CurrentsSteps.FifthStep, CurrentsSteps.SixStep].includes(currentStep)
                                                ? <>
                                                    <p
                                                        style={{ ...txtdefault, marginTop: '3vh', bottom: 0 }}>
                                                        Al continuar estás aceptando la
                                                        <a onClick={() => window.open("https://www.finbeabc.com.mx/aviso-de-privacidad")}> Política de Privacidad de FinBe ABC </a>
                                                    </p></>
                                                :
                                                <></>
                                            }

                                        </>
                                    )
                                }

                            </Space>
                        )
                }
            </Col>
        </Row>
    );
}
